import React from 'react';
import { ChevronRightIcon, HomeIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export interface BreadcrumbItem {
  label: string;
  href?: string;
}
interface BreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
}
export const Breadcrumb: React.FC<BreadcrumbProps> = ({
  items,
  className = ''
}) => {
  return <nav className={`flex text-sm text-text-secondary ${className}`} aria-label="Breadcrumb" data-id="element-156">
      <ol className="inline-flex items-center space-x-1 md:space-x-2" data-id="element-157">
        <li className="inline-flex items-center" data-id="element-158">
          <Link to="/" className="inline-flex items-center hover:text-fpg-navy transition-colors" data-id="element-159">
            <HomeIcon className="w-4 h-4 mr-1" data-id="element-160" />
            <span className="sr-only" data-id="element-161">Home</span>
          </Link>
        </li>
        {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return <li key={item.label} className="flex items-center" data-id="element-162">
              <ChevronRightIcon className="w-4 h-4 text-text-tertiary mx-1" data-id="element-163" />
              {isLast || !item.href ? <span className="text-text-primary font-medium" aria-current="page" data-id="element-164">
                  {item.label}
                </span> : <Link to={item.href} className="hover:text-fpg-navy transition-colors" data-id="element-165">
                  {item.label}
                </Link>}
            </li>;
      })}
      </ol>
    </nav>;
};